import { Button, Card, CardContent } from "@repo/ui";
import { Download } from "lucide-react";

import { Footer } from "@/components/footer";
import { Nav } from "@/components/nav";

export function Resume() {
  return (
    <div className="min-h-screen flex flex-col">
      <Nav />
      <section className="mx-auto max-w-3xl px-4 md:px-6 py-12">
        <h1 className="text-3xl md:text-4xl font-semibold mb-6">Resume</h1>
        <p className="text-foreground/70 mb-6">Download a PDF version or view highlights below.</p>
        <a href="/jenn-mueng-resume.pdf" download>
          <Button className="h-10 px-6">
            <Download className="size-4 mr-2" />
            Download PDF
          </Button>
        </a>
        <Card className="mt-8 bg-card/60">
          <CardContent className="p-6 space-y-4">
            <div>
              <h3 className="text-xl font-semibold">Experience</h3>
              <ul className="mt-2 list-disc pl-5 text-foreground/80">
                <li>Senior Software Engineer — Focus on TypeScript, React, Node</li>
                <li>Built performant, accessible interfaces and APIs</li>
              </ul>
            </div>
            <div>
              <h3 className="text-xl font-semibold">Skills</h3>
              <p className="text-foreground/80">
                TypeScript, React, Node.js, Hono, Drizzle, Postgres, Tailwind, Testing
              </p>
            </div>
          </CardContent>
        </Card>
      </section>
      <Footer />
    </div>
  );
}
